export default __webpack_public_path__ + "static/media/comm 7.0010e549.png";